import { AnyAction }        from 'redux';
import { IRootState }       from '@store/rootReducer';
import { SET_CURRENT_CUID } from './accountManagementActions';

export interface IAccountState {
  currentCUID: string | null;
}

const initState = {
  currentCUID: null,
};

const setCurrentCUID = (state = initState, action: AnyAction): IAccountState => ({
  ...state,
  currentCUID: action.payload,
});

const strategies = {
  [SET_CURRENT_CUID] : setCurrentCUID,
  defaultState       : (state: IAccountState): IAccountState => state,
};

export const accountManagement = (state = initState, action: AnyAction): any => {
  const transformer = strategies[action.type] ?? strategies.defaultState;

  return transformer(state, action);
};

export const getCurrentCUID = (
  state: IRootState,
): string | null => state.accountManagement.currentCUID;
